import {
  CREATE_DAYS_IN_MONTH,
  SELECTED_DATE,
  SELECTED_MONTH,
  REQUEST_SPECIALIST_BY_HOSPITAL,
  SELECTED_SPECIALIST,
  HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST,
  HIDE_MODAL_FILTER_SPECIALIST,
  SET_SEARCH_PATTERN,
  ADD_SPECIALIST_MORE,
  FILL_BY_FOLLOWUP,
  RESET_ALL_PROPS_DATE_AND_SPECIALIST,
  HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY,
  SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY,
  SHOW_ALERT_MAX_SPECIALIST,
  HIDE_ALERT_MAX_SPECIALIST,
  SHOW_ALERT_HOLIDAY_MODAL,
  HIDE_ALERT_HOLIDAY_MODAL,
  SHOW_ALERT_GUIDE_LINE_MODAL,
  HIDE_ALERT_GUIDE_LINE_MODAL,
  SELECTED_CALENDAR_SHOW_ONE_ROW,
  CLOSE_TO_CHOOSE_CALENDAR_AGAIN,
  HIDE_LIST_SPECIALIST_INLINE,
  RESET_SELECT_DATE_AND_SPECIALIST,
  RESET_ADD_MORE_SPECIALIST,
  RESET_SHOW_ONE_ROW,
  RESET_SELECT_DATE
} from "./dateAndSpecialistTypes";

export const createDaysInMonth = (currentDate, selectedMonth) => {
  return {
    type: CREATE_DAYS_IN_MONTH,
    currentDate,
    selectedMonth
  };
};

export const selectedDate = date => {
  return {
    type: SELECTED_DATE,
    date
  };
};

export const selectedMonth = month => {
  return {
    type: SELECTED_MONTH,
    month
  };
};

export const requestAllSpecialist = () => {
  return {
    type: REQUEST_SPECIALIST_BY_HOSPITAL
  };
};

export const selectedSpecialist = specialist => {
  return {
    type: SELECTED_SPECIALIST,
    specialist
  };
};

export const hideModalConfirmSelectedSpecialist = () => {
  return {
    type: HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST
  };
};

export const hideModalFilterSpecialist = () => {
  return {
    type: HIDE_MODAL_FILTER_SPECIALIST
  };
};

export const setSearchPattern = pattern => {
  return {
    type: SET_SEARCH_PATTERN,
    pattern
  };
};

export const addSpecialistMore = date => {
  return {
    type: ADD_SPECIALIST_MORE,
    date
  };
};

export const showAlertMaxSpecialist = () => {
  return {
    type: SHOW_ALERT_MAX_SPECIALIST
  };
};

export const hideAlertMaxSpecialist = () => {
  return {
    type: HIDE_ALERT_MAX_SPECIALIST
  };
};

export const fillByFollowUp = data => {
  return {
    type: FILL_BY_FOLLOWUP,
    data
  };
};

export const resetDateAndSpecialist = () => {
  return {
    type: RESET_ALL_PROPS_DATE_AND_SPECIALIST
  };
};

export const resetSelectDateAndSpecialist = () => {
  return {
    type: RESET_SELECT_DATE_AND_SPECIALIST
  };
};

export const resetSelectDate = () => {
  return {
    type: RESET_SELECT_DATE
  };
};

export const closeAlertYearOfChild = () => {
  return {
    type: HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY
  };
};

export const showAlertInvalidYearWithSpeciality = message => {
  return {
    type: SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY,
    message
  };
};

export const showAlertHolidayModal = () => {
  return {
    type: SHOW_ALERT_HOLIDAY_MODAL
  };
};

export const hideAlertHolidayModal = () => {
  return {
    type: HIDE_ALERT_HOLIDAY_MODAL
  };
};

export const showGuideLineModal = () => {
  return {
    type: SHOW_ALERT_GUIDE_LINE_MODAL
  };
};

export const hideGuideLineModal = () => {
  return {
    type: HIDE_ALERT_GUIDE_LINE_MODAL
  };
};

export const selectedShowOneRow = () => {
  return {
    type: SELECTED_CALENDAR_SHOW_ONE_ROW
  };
};

export const resetShowOneRow = () => {
  return {
    type: RESET_SHOW_ONE_ROW
  };
};

export const closeToChooseCalendarAgain = () => {
  return {
    type: CLOSE_TO_CHOOSE_CALENDAR_AGAIN
  };
};

export const hideListSpecialistInline = () => {
  return {
    type: HIDE_LIST_SPECIALIST_INLINE
  };
};

export const resetAddMoreSpecialist = () => {
  return {
    type: RESET_ADD_MORE_SPECIALIST
  };
};
